import React from 'react';
import {message as antdMessage} from 'antd';
import { EmptyIcon, FailedIcon } from './Icons';
import { GlobalSettingsContextProvider } from 'contexts/GlobalSettingsContext';
import { ActiveUserContextProvider } from 'contexts/ActiveUserContext';
import _ from 'lodash';

const antdMessageContent = ({type, heading = '', content, duration = 10, icon, key: _key}) => {
    const key = _key || Math.random();
    if(heading){
        heading = <><strong>{heading}</strong> <br/></>
    }
    let _content = <>
        {heading} {content} <span className="message-close" onClick={() => antdMessage.destroy(key)}>x</span>
    </>;
    if(!_.isString(content)){
        // add providers only if the message is not a string
        _content = (
            <ActiveUserContextProvider>
                <GlobalSettingsContextProvider allowApiFetch={false}>
                    {_content}
                </GlobalSettingsContextProvider>
            </ActiveUserContextProvider>
        )
    }
    return(
        antdMessage[type]({
            key,
            content: _content,
            duration,
            icon
        })
    )
}

const message = {
    success(content, duration) {
        return antdMessageContent({type: 'success', heading: "Success!", content, duration})
    },
    error(content, duration, key){
        return antdMessageContent({type: 'error', heading: 'Failed!', content, duration, icon: <FailedIcon />, key});
    },
    warn(content, duration){
        return antdMessageContent({type: 'warning', content, duration, icon: <EmptyIcon />});
    },
    info(content, duration){
        return antdMessageContent({type: 'info', content, duration});
    },
    loading(content, duration){
        return antdMessageContent({type: 'loading', content, duration});
    },
    open(content, duration){
        return antdMessageContent({type: 'open', content, duration});
    },
}

export default message;